require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-garfield-grant-jamaica-native-turned-senior-consultant.json") })
        }
      }, "path---blog-meet-garfield-grant-jamaica-native-turned-senior-consultant");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-garfield-grant-jamaica-native-turned-senior-consultant!./.cache/json/blog-meet-garfield-grant-jamaica-native-turned-senior-consultant.json
// module id = 957
// module chunks = 231608221292675